import template from './secureFileUploaderCompleteStage.html';
import controller from './secureFileUploaderCompleteStage.controller';

let secureFileUploaderCompleteStageComponent = {
  restrict: 'E',
  bindings: {
    uploadState: '='
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default secureFileUploaderCompleteStageComponent;



// WEBPACK FOOTER //
// ./app/components/secureFileUploaderCompleteStage/secureFileUploaderCompleteStage.component.js